import React, { Component, useEffect, useState } from 'react';
import Diamond2025 from './visualisation/diamond2025.jsx'
import diamond2025Data from "../../data/diamond2025_data.js"
import gsap from "gsap";
import * as d3 from "d3";

function Test (props) {

    const [selection, setSelection] = useState([])
    const [hover, setHover] = useState()
    const [layout, setLayout] = useState({w: window.innerWidth, h: window.innerHeight})

    const unselected = selection.length === 0;
    const unhovered = hover === undefined;
    
    const width = getWidth()
    const barScale = d3.scaleLinear().domain([0,2]).range([10, width/3])

    window.addEventListener('resize', getLayout());

    function getLayout(){
        const newWidth = window.innerWidth;
        const newHeight = window.innerHeight;
        if (newWidth !== layout.w || newHeight !== layout.h) setLayout({w: newWidth, h: newHeight})
    }

    function getWidth(){
        const sizeWidth = layout.w * 1
        const sizeHeight = layout.h * 0.65
        const size = d3.min([sizeWidth, sizeHeight])
        return size
    }

    function getPath (element) {

        const rectID = element.id
        var corner1, corner2, corner3, corner4

        if (unselected || selection.length === 9) {
            corner1 = false
            corner2 = false
            corner3 = false
            corner4 = false
        } else if (selection.length === 1 || !selection.find(el => el.id === rectID)) {
            corner1 = true
            corner2 = true
            corner3 = true
            corner4 = true
        } else {
            const top = selection.find(el => el.mas === element.mas + 1 && el.fem === element.fem),
                right = selection.find(el => el.mas === element.mas && el.fem === element.fem + 1),
                bottom = selection.find(el => el.mas === element.mas - 1 && el.fem === element.fem),
                left = selection.find(el => el.mas === element.mas && el.fem === element.fem - 1);
            
            corner1 = !(left || top)
            corner2 = !(top || right)
            corner3 = !(right || bottom)
            corner4 = !(bottom || left)
        }
        
        const points = element.d.match(/-?\d+(\.\d+)?/g).map(Number);
        const [x1, y1, x2, y2, x3, y3, x4, y4, x5, y5] = points;

        const radiusFactor = 0.4;
        const side1 = Math.hypot(x2 - x1, y2 - y1);
        const side2 = Math.hypot(x3 - x2, y3 - y2);
        const side3 = Math.hypot(x4 - x3, y4 - y3);
        const side4 = Math.hypot(x1 - x4, y1 - y4);
        
        const r1 = corner1 ? radiusFactor * Math.min(side1, side4) : 0;
        const r2 = corner2 ? radiusFactor * Math.min(side1, side2) : 0;
        const r3 = corner3 ? radiusFactor * Math.min(side2, side3) : 0;
        const r4 = corner4 ? radiusFactor * Math.min(side3, side4) : 0;

        return `
            M ${x1 + r1},${y1 - r1}  
            L ${x2 - r2},${y2 + r2}  
            ${`Q ${x2},${y2} ${x2 + r2},${y2 + r2}`}
            L ${x3 - r3},${y3 - r3}  
            ${`Q ${x3},${y3} ${x3 - r3},${y3 + r3}`}
            L ${x4 + r4},${y4 - r4}  
            ${`Q ${x4},${y4} ${x4 - r4},${y4 - r4}`}
            L ${x1 + r1},${y1 + r1}  
            ${`Q ${x1},${y1} ${x1 + r1},${y1 - r1}`}
            Z
        `;
        };

    function typeGenderName () {
        if (unselected && unhovered) return 'Select a gender...'
        else return hover.name
    }

    function typeGenderDescription () {
        if (unselected && unhovered) return undefined
        else return hover.description
    }

    function colorGender () {
        if (unselected && unhovered) return 'gray'
        else return hover.fill
    }

    function updateRects () {

        d3.select('#rects')
            .selectAll('.rect')
                .data(diamond2025Data)
                .join('path')
                    .style('cursor', 'pointer')
                    .style('stroke', d => d.fill)
                    .style('stroke-width', 5)
                    .on('mouseenter', (e,d) => setHover(d))
                    .on('click', (e,d) => {
                        var newSelection = [...selection]
                        if (selection.find(el => el.id === d.id)) newSelection = newSelection.filter(el => el.id !== d.id)
                        else newSelection = [...newSelection, d]
                        setSelection(newSelection)
                    })
                    .transition()
                    .duration(1000)
                    .ease(d3.easeSinInOut)
                    .attr('d', d =>  getPath(d))
                    .style('opacity', d => {
                        if (hover?.id === d.id) return 1
                        else if (unselected || selection.find(el => el.id === d.id)) return 0.9
                        else return 0
                    })
    }

    function updateBars () {
        if (hover) {
            d3.select('#bar_fem').transition().ease(d3.easeSinInOut).duration(500).attr('width', barScale(hover.fem) + 100);
            d3.select('#bar_mas').transition().ease(d3.easeSinInOut).duration(500).attr('width', barScale(hover.mas) + 100);
        } else d3.selectAll('#bar_fem, #bar_mas').transition().ease(d3.easeSinInOut).duration(1000).attr('width',  barScale(0));
    }

    function wobbleElements() {
        gsap.utils.toArray(".label").forEach((el, index) => {
            gsap.to(el, {
              duration: gsap.utils.random(2, 6), // Random duration between 0.5s and 1s
              repeat: -1,
              yoyo: true,
              rotate: `${gsap.utils.random(-4, 4)}deg`, // Random rotation between 3° and 7°
              x: gsap.utils.random(-15, 15), // Random side movement
              y: gsap.utils.random(-15, 15), // Slight vertical movement
              transformOrigin: "center",
              ease: "sine.inOut",
              delay: index * 0.1, // Slight delay for a natural effect
            });
          });

        gsap.utils.toArray(".rect").forEach((el, index) => {
        gsap.to(el, {
            duration: gsap.utils.random(5, 10), // Random duration between 0.5s and 1s
            repeat: -1,
            yoyo: true,
            rotate: `${gsap.utils.random(-5, 5)}deg`, // Random rotation between 3° and 7°
            x: gsap.utils.random(-18, 18), // Random side movement
            y: gsap.utils.random(-18, 18), // Slight vertical movement
            scale: gsap.utils.random(1.1, 1.3),
            transformOrigin: "center",
            ease: "sine.inOut",
            delay: index * 0.1, // Slight delay for a natural effect
        });
        });
    }

    useEffect(() => {
        d3.select('#diamond').transition().duration(3000).style('opacity', 1)
        
        updateRects()
        updateBars()
        wobbleElements()
    })

    return (
        <div id="visualisation">
            <div id="chart" width={width}>
                <Diamond2025 />
            </div>
            <div id="hover" width={width}>
                <svg id="hover_barchart" 
                    style={{
                        width: width/3,
                        height: "4em",
                        background: 'white',
                        flexGrow: 0,
                    }}
                >
                    <defs>
                        <filter id="barsBlur">
                        <feGaussianBlur stdDeviation="7" />
                        </filter>
                    </defs>
                    <g id="bars" filter="url(#barsBlur)">
                        <rect id="bar_fem" className="bar"  x={-100} y="-0.5em" style={{fill: '#e94dff'}}/>
                        <rect id="bar_mas" className="bar" filter="url(#barsBlur)" x={-100} y="1.5em" style={{fill: '#27dde5'}}/>
                    </g>
                    <g id="lines">
                        <line x1={barScale(0)} x2={barScale(0)} y1={0} y2="4em" />
                        <line x1={barScale(1)} x2={barScale(1)} y1={0} y2="4em" />
                    </g>
                </svg>
                <div id="hover_info" 
                    style={{
                        height: "4em",
                        width:width/3*2,
                        backgroundColor: colorGender(),
                        display: "flex",
                        flexWrap: "wrap",
                        alignContent: "center",
                        justifyItems: "center",
                        justifyContent: "center"
                    }}
                >
                    <p style={{width: '100%', margin: 0, color: 'black', fontWeight: 500, textAlign: "center" }}>{typeGenderName()}</p>
                    <h6 style={{maxWidth: '14em', color: 'black', textAlign: "center", opacity: 0.7}}>{typeGenderDescription()}</h6>
                </div>
            </div>
        </div>
    )

}

export default Test